import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type Props = {
  mode: "create" | "update";
  disabled?: boolean;
  compact?: boolean;
  onCreate: () => void;
  onViewPlan: () => void;
};

export function AssistantProposalActionBar({
  mode,
  disabled = false,
  compact = false,
  onCreate,
  onViewPlan,
}: Props) {
  const primaryLabel = mode === "create" ? "Create" : "Update";

  return (
    <div
      className={cn(
        "flex flex-wrap justify-end gap-2",
        compact
          ? "border-t border-[rgba(15,23,42,0.06)] px-3 py-2 dark:border-white/10"
          : "border-t border-[var(--lm-border-subtle)] px-4 py-3 dark:border-white/10"
      )}
    >
      <Button
        type="button"
        variant={compact ? "surface" : "surface"}
        size={compact ? "xs" : "sm"}
        onClick={onViewPlan}
        disabled={disabled}
      >
        View Plan
      </Button>
      <Button
        type="button"
        variant="default"
        size={compact ? "xs" : "sm"}
        onClick={onCreate}
        disabled={disabled}
      >
        {primaryLabel}
      </Button>
    </div>
  );
}
